<template>
    <div class="space-y-6">
        <div class="flex items-center justify-between">
            <h2 class="text-heading-md">Search Input Examples</h2>
            <div class="flex items-center gap-4">
                <span class="text-content-md font-medium text-content-secondary">Size:</span>
                <DsRadio
                    v-model="size"
                    label="Medium (default)"
                    name="search-input-size"
                    value="md"
                />
                <DsRadio
                    v-model="size"
                    label="Small"
                    name="search-input-size"
                    value="sm"
                />
            </div>
        </div>

        <h3 class="mb-4 border-b border-ds-primary-200 pb-2 text-heading-sm">Basic States</h3>

        <div class="grid grid-cols-2 gap-4">
            <DsSearchInput
                v-model="emptyValue"
                label="Empty"
                placeholder="Search files"
                :size
            />

            <DsSearchInput
                v-model="filledValue"
                label="With a value"
                placeholder="Search files"
                :size
            />

            <DsSearchInput
                v-model="disabledValue"
                disabled
                label="Disabled"
                :size
            />

            <DsSearchInput
                v-model="readonlyValue"
                label="Readonly"
                readonly
                :size
            />
        </div>

        <h3 class="mb-4 border-b border-ds-primary-200 pb-2 text-heading-sm">Labels & Helper Text</h3>

        <div class="grid grid-cols-2 gap-4">
            <DsSearchInput
                v-model="tooltipValue"
                label="With info icon"
                labelTooltip="Searches by file number, address, or client name"
                :size
            />

            <DsSearchInput
                v-model="customTooltipValue"
                label="With custom tooltip"
                :size
            >
                <template #labelTooltip>
                    <div>
                        Custom tooltip with
                        <strong>rich content</strong>
                    </div>
                </template>
            </DsSearchInput>

            <DsSearchInput
                v-model="helperValue"
                helperText="Results update as you type"
                label="With helper text"
                :size
            />

            <DsSearchInput
                v-model="helperSlotValue"
                label="With helper text slot"
                :size
            >
                <template #helperText> Custom helper text content goes here </template>
            </DsSearchInput>
        </div>

        <h3 class="mb-4 border-b border-ds-primary-200 pb-2 text-heading-sm">Error & Warning</h3>

        <div class="grid grid-cols-2 gap-4">
            <DsSearchInput
                v-model="errorValue"
                error="Search term is too short"
                label="With error"
                :size
            />

            <DsSearchInput
                v-model="warningValue"
                label="With warning"
                :size
                warning="No exact matches, showing similar results"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import DsSearchInput from '@ds/form/input/DsSearchInput/DsSearchInput.vue';
import DsRadio from '@ds/form/input/DsRadio.vue';
import type { DsInputSize } from '@ds/form/input/text/text-input.types';
import { ref } from 'vue';

const size = ref<DsInputSize>('md');

const emptyValue = ref('');
const filledValue = ref('123 Main St');
const disabledValue = ref('Disabled search');
const readonlyValue = ref('Readonly search');

const tooltipValue = ref('');
const customTooltipValue = ref('');
const helperValue = ref('');
const helperSlotValue = ref('');

const errorValue = ref('ab');
const warningValue = ref('123 Main St');
</script>
